if (!customElements.get('mega-drawer')) {
  class MegaDrawer extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('.mega-drawer');
      this.toggleButtons = document.querySelectorAll('[data-mega-drawer-toggle]');
      this.imageLabel = this.querySelector('[data-mega-drawer-label]');
      this.defaultLabel = this.imageLabel ? this.imageLabel.textContent : '';

      if (!this.drawer || this.toggleButtons.length === 0) return;

      this.toggleButtons.forEach((button) =>
        button.addEventListener('click', () => {
          if (this.isOpen() && performance.now() - this.hoverOpenedAt < 600) return;
          this.isOpen() ? this.close() : this.open();
        })
      );

      this.initHoverIntent();

      this.querySelectorAll('[data-mega-drawer-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );

      this.querySelectorAll('.mega-drawer__column a, .mega-drawer__cta a, .mega-drawer__utils a').forEach((a) =>
        a.addEventListener('click', () => this.close())
      );

      document.addEventListener('keyup', (event) => {
        if (event.code === 'Escape' && this.isOpen()) this.close();
      });

      this.groups = this.querySelectorAll('[data-mega-drawer-group]');
      this.desktopQuery = window.matchMedia('(min-width: 1000px)');
      this.syncGroups();
      this.desktopQuery.addEventListener('change', () => this.syncGroups());

      this.groups.forEach((group) =>
        group.addEventListener('toggle', () => {
          if (this.desktopQuery.matches || !group.open) return;
          this.groups.forEach((other) => {
            if (other !== group) other.removeAttribute('open');
          });
        })
      );

      this.initPreview();
    }

    initHoverIntent() {
      this.hoverOpenedAt = -Infinity;
      const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      const overlay = this.querySelector('.mega-drawer__overlay');

      this.toggleButtons.forEach((button) =>
        button.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !finePointer.matches || this.isOpen()) return;
          this.hoverOpenedAt = performance.now();
          this.open();
        })
      );

      if (!overlay) return;

      overlay.addEventListener('pointermove', (event) => {
        if (event.pointerType !== 'mouse' || !this.isOpen()) return;
        if (performance.now() - this.openedAt < 600) return;
        this.close();
      });
    }

    initPreview() {
      this.categoryLabel = this.querySelector('[data-mega-drawer-category]');
      this.slides = new Map();
      this.querySelectorAll('[data-mega-drawer-image]').forEach((slide) =>
        this.slides.set(slide.dataset.megaDrawerImage, slide)
      );
      this.defaultSlide = this.slides.get('default');

      this.querySelectorAll('.mega-drawer__column').forEach((column) => {
        const title = column.querySelector('.mega-drawer__title');
        const columnTitle = column.dataset.title || (title ? title.textContent.trim() : '');

        column.addEventListener('mouseenter', () => this.preview(columnTitle, ''));
        column.addEventListener('mouseleave', () => this.preview('', ''));

        column.querySelectorAll('a').forEach((link) => {
          const linkTitle = (link.dataset.label || link.textContent).trim();
          link.addEventListener('mouseenter', (event) => {
            event.stopPropagation();
            this.preview(columnTitle, linkTitle);
          });
        });
      });
    }

    preview(columnTitle, linkTitle) {
      if (this.imageLabel) {
        this.imageLabel.textContent = columnTitle || this.defaultLabel;
      }

      if (this.categoryLabel) {
        this.categoryLabel.textContent = linkTitle;
        this.categoryLabel.toggleAttribute('hidden', linkTitle === '');
      }

      if (!this.defaultSlide) return;

      const slide =
        this.slides.get(linkTitle.toLowerCase()) ||
        this.slides.get(columnTitle.toLowerCase()) ||
        this.defaultSlide;

      this.slides.forEach((element) => element.classList.toggle('is-visible', element === slide));
    }

    syncGroups() {
      const isDesktop = this.desktopQuery.matches;
      this.groups.forEach((group) => group.toggleAttribute('open', isDesktop));
    }

    isOpen() {
      return this.drawer.classList.contains('mega-drawer--open');
    }

    open() {
      this.openedAt = performance.now();
      this.drawer.removeAttribute('hidden');
      this.drawer.getBoundingClientRect();
      this.drawer.classList.add('mega-drawer--open');
      this.toggleButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      this.drawer.classList.remove('mega-drawer--open');
      this.syncGroups();
      this.preview('', '');
      this.toggleButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      document.documentElement.style.overflow = '';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.drawer.setAttribute('hidden', '');
        return;
      }

      this.drawer.addEventListener(
        'transitionend',
        () => {
          if (!this.isOpen()) this.drawer.setAttribute('hidden', '');
        },
        { once: true }
      );
    }
  }

  customElements.define('mega-drawer', MegaDrawer);
}
